export const scroll = {
  smoother: "",
  smootherMenu: "",
  init: function () {

    $(".anchor-nav").on("click", function (e) {
      e.preventDefault();
      const target = $(this).find('a').attr("href");
      gsap.to(window, {
        scrollTo: {
          y: target,
          offsetY: 50,
        },
        duration: 1.5,
        ease: "power3.inOut",
      });
    });

    let mm = gsap.matchMedia();

    mm.add("(min-width: 769px)", () => {
      // Create smooth scroller with GSAP ScrollSmoother
      this.smoother = ScrollSmoother.create({
        id:"main",
        wrapper: ".rt-container",
        content: ".site-content",
        effects: true,
        smoothTouch: 0.1,
        
      });
    });
    mm.add("(max-width: 768px)", () => {
      ScrollTrigger.create({
        trigger: ".hero-title-home",
        start: "bottom 85%",
        end: () => `+=${$(window).height() * 0.3}`,
        scrub: true,
        pin: true,
        pinSpacing: false,
      });
    })

  },
};
